import { render, staticRenderFns } from "./uploaderRecom.vue?vue&type=template&id=bde9c66e&"
import script from "./uploaderRecom.vue?vue&type=script&lang=js&"
export * from "./uploaderRecom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde9c66e')) {
      api.createRecord('bde9c66e', component.options)
    } else {
      api.reload('bde9c66e', component.options)
    }
    module.hot.accept("./uploaderRecom.vue?vue&type=template&id=bde9c66e&", function () {
      api.rerender('bde9c66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/uploader/components/uploaderRecom.vue"
export default component.exports